<template>
  <div class="page birra">
    <ListingList
      :indexes="indexes"
      :pageHandle="birraPage.typeHandle"
      :categories="categories"
      :subcategories="subcategories"
      :introSection="birraPage.sezioneIntroProdotti[0]"
      :parentIntroSectionImage="birraPage.sezioneIntroProdotti[0].portrait"
    />
    <ListingIntro
      :introSection="birraPage.sezioneIntroProdotti[0]"
      class="hide-for-large"
    />
    <PagesVinoBirraPreFooterSection
      :preFooterSection="birraPage.sezionePreFooter[0]"
    />
  </div>
</template>

<script setup>
import { useStore } from '@/store/index.js'
import { useHelpers } from '~/composables/helpers.js'
import queries from '@/graphql/craft/queries/index.js'
import { useBirraData } from '~/composables/birra-data.js'

const indexes = ['section_birra']

const { configuration } = useStore()

const query = queries.birraPage.getBirraPage

const variables = computed(() => ({
  site: configuration.site,
}))

const { data } = await useGraphql(query, variables)

if (!data.value.birraPageEntries?.[0]) {
  throw createError({ statusCode: 404 })
}
const birraPage = computed(() => data.value.birraPageEntries?.[0])

const { categories, subcategories } = useBirraData(data)

const seo = computed(() => data.value?.birraPageEntries?.[0]?.seo || {})

useSeo({
  ...seo.value,
  meta: [
    {
      name: 'description',
      content: seo.value?.description,
    },
  ],
})
</script>
